export const GRAPH_NOT_YET_SAVED_ID = 'new';

export const DATE_TIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  dateStyle: 'short',
  timeStyle: 'short',
  timeZone: 'America/Los_Angeles',
});

export const TIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  timeStyle: 'short',
  timeZone: 'America/Los_Angeles',
});

export function addVolumeBuffer(nl: number): number {
  // Add either 0.1x or 5ul, whichever is lower
  return Math.min(nl * 1.1, nl + 5000);
}
